import { render, staticRenderFns } from "./receiving.vue?vue&type=template&id=79df4e6e&"
import script from "./js/receiving.js?vue&type=script&lang=js&"
export * from "./js/receiving.js?vue&type=script&lang=js&"
import style0 from "./receiving.vue?vue&type=style&index=0&id=79df4e6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports